import { fetchBranchConfig } from './apis/branchApi';
import { isFeatureEnabledForBranch } from './apis/featureApi';
import BranchConfig from './enums/branch_config';
import Features from './enums/features';

let hoursToCancel = 0; // Default value
let isPenalizationFeatureOn = false; // Default value
let isHoursToCancelFeatureOn = false; // Default value

export const loadGlobalConfig = async () => {
    isPenalizationFeatureOn = await isFeatureEnabledForBranch(Features.PENALIZATION);
    isHoursToCancelFeatureOn = await isFeatureEnabledForBranch(Features.HOURS_TO_CANCEL);
    try {
        hoursToCancel = await fetchBranchConfig(BranchConfig.HOURS_TO_CANCEL);
    }
    catch (error) { // perhaps the parameter is not set, since branch does not ask customers to cancel in advance 
        hoursToCancel = 0;
    }
};

export const getHoursToCancel = () => hoursToCancel;
export const getIsPenalizationFeatureOn = () => isPenalizationFeatureOn;
export const getIsHoursToCancelFeatureOn = () => isHoursToCancelFeatureOn;